module.exports = __webpack_public_path__ + "6fb8a9a82b37b1ef9ac1c6b3c81576b6.jpg";